import React from 'react';
import { useTranslation } from 'react-i18next';

const InvalidDetails = () => {
  const [translation] = useTranslation();
  return <h1>{translation('Error')}</h1>;
};

export default InvalidDetails;
